import React from "react";

const TicketTableHeader = ({ columns = [], onSort, sortConfig }) => {
  return (
    <thead>
      <tr>
        {columns.map((header) => (
          <th
            key={header.key}
            className={`cursor-pointer border-b-5 p-2 transition-colors ${
              header.sortable ? "hover:bg-blue-gray-50" : ""
            }`}
            onClick={() => header.sortable && header.key && onSort(header.key)}
          >
            <p className="font-20-30-400 flex items-center gap-10 cursor-pointer">
              {header.label}
              {header.sortable && header.key && sortConfig.key === header.key && (
                sortConfig.direction === "asc" ? <span>▲</span> : <span>▼</span>
              )}
              {header.sortable && header.key && sortConfig.key !== header.key && <span>↕</span>}
            </p>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TicketTableHeader;
